<template>
  <div class="inspectionShipment">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="inspectionShipment.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="600px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          style="position: relative"
          :model="inspectionShipment"
          :rules="ruleValidate"
          class="form"
          label-width="70px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="工序：">
              <el-select v-model="inspectionShipment.process" clearable size="mini" placeholder="请选择">
                <el-option
                    v-for="item in constants.process.$options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="物料号：">
              <el-input v-model="inspectionShipment.materialNo" placeholder="请输入" readonly>
                <el-button slot="append" icon="el-icon-search" @click="$refs.selectManageMaterial.open()">
                  选择物料
                </el-button>
              </el-input>
              <material-select ref="selectManageMaterial" @select="selectManageMaterial"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="状态：">
              <el-radio-group v-model="inspectionShipment.status">
                <el-radio :label="0">无效</el-radio>
                <el-radio :label="1">有效</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button type="info" @click="dialogVisible=false">关闭</el-button>
        <el-button :loading="submitLoading" type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import MaterialSelect from "@/views/information/SupplierManage/MaterialSelect";
  import constants from "@/util/constants.js";
  

  export default {
    name: "InspectionShipmentEdit",
    components: { MaterialSelect },
    data() {
      return {
        constants,
        editAuth: this.$auth(832),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        inspectionShipment: {
          pkid: 0,
          process: "",
          materialNo: "",
          materialName: "",
          status: 1,
        },
        ruleValidate: {
          process: {required: true, message: "不能为空", trigger: "blur"},
          materialNo: {required: true, message: "不能为空", trigger: "blur"},
          status: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if(row) {
          this.inspectionShipment = row;
        }
      },
      selectManageMaterial(row) {
        this.inspectionShipment.materialNo = row.no;
        this.inspectionShipment.materialName = row.name;
      },

      //保存
      save() {
        this.$refs.form.validate(valid => {
          if (!valid) {
            return;
          }
          this.submitLoading = true;
          let queryType="post";
          if(this.inspectionShipment.pkid) {
            queryType="put";
          }
          this.$http[queryType]("basic", "checkManges", this.inspectionShipment)
            .then(() => {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.$emit("save-success");
              this.dialogVisible = false;
            })
            .finally(() => {
              this.submitLoading = false;
            });
        });
      },
    },
  };
</script>

<style lang="scss">
  .inspectionShipment {
    .table {
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #dddddd;
      border-left: 1px solid #dddddd;

      .tableLabel {
        width: 130px;
        padding: 1%;
        background: #f4f7fa;
        border-bottom: 1px solid #dddddd;
      }

      .tableModel {
        width: 20%;
        padding: 1%;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
      }
    }
  }

</style>
